// extracted by mini-css-extract-plugin
module.exports = {"icon":"iconography-moduleicon1H4","iconBaseline":"iconography-moduleiconBaseline3B_"};